// Vaidvana non-color design tokens — hero typography, radius, and shadows.
// Colors live in palette.ts (mapped to MUI palette slots); these are the
// remaining "single source of truth" values so components never hardcode
// font-sizes, radii, or shadow strings.
//
// Exposed on the MUI theme as `theme.brand` (see augmentation below), so any
// component can read e.g. `theme.brand.hero.headlineSize`.
import { statusColors } from './statusColors';

export const brand = {
  // Harmonized status palette (see statusColors.ts).
  status: statusColors,

  hero: {
    fontWeight: 500, // hero headline weight — medium, never bold
    letterSpacing: '-0.01em',
    eyebrowLetterSpacing: '0.12em',
    eyebrowSize: '0.75rem',
    headlineSize: 'clamp(2.5rem, 5vw, 4.25rem)',
    headlineLineHeight: 1.1,
    subheadSize: 'clamp(1.05rem, 1.5vw, 1.25rem)',
    subheadLineHeight: 1.55,
    smallSize: '0.875rem',
    headlineMaxWidth: '18ch',
    subheadMaxWidth: '60ch',
    contentMaxWidth: 1100,
    sectionPadding: 'clamp(80px, 12vh, 160px)',
    minHeight: '85vh',
  },
  radius: {
    sm: 6,
    md: 8,
    lg: 12,
  },
  shadow: {
    sm: '0 1px 2px rgba(15, 76, 58, 0.06)',
    md: '0 4px 12px rgba(15, 76, 58, 0.08)',
    lg: '0 12px 28px -16px rgba(15, 76, 58, 0.18)',
  },
} as const;

export type BrandTokens = typeof brand;

// Make `theme.brand` typed everywhere it's read.
declare module '@mui/material/styles' {
  interface Theme {
    brand: BrandTokens;
  }
  interface ThemeOptions {
    brand?: BrandTokens;
  }
}
